import { useMemo } from "react";
import { ChatType, ThisChatData } from "../types/chat";

/**
 * Hook to determine chat type based on chat metadata
 * Extracted from mobile (Chat.tsx) and desktop (ChatPanel.tsx)
 * 
 * @param chatType - The chatCategory from Firestore chat document
 * @param thisChat - The chat metadata from user's chats collection
 * @returns The resolved chat type: "DM", "JobMsg", or "Support"
 */
export function useChatType(chatType: ChatType, thisChat: ThisChatData | null): ChatType {
  const resolvedChatType = useMemo(() => {
    // Prefer chat doc category once known; otherwise infer from chats/{uid} DMuid field
    if (chatType === "DM" || chatType === "JobMsg") return chatType;
    return thisChat?.DMuid ? "DM" : "JobMsg";
  }, [chatType, thisChat?.DMuid]);

  return resolvedChatType;
}
